/* @flow */
import * as React from 'react';

import Text from './Text';
import type { SupportedFontSize } from './Text';
import type { ResponsiveValue } from '../../constants/Responsive';

const MARGIN_TOP: { [size: SupportedFontSize]: number } = {
  '14': 8,
  '15': 8,
  '16': 10,
  '17': 10,
  '18': 10,
  '20': 14,
  '24': 14,
  '28': 16,
};

export default function BodyText({
  size,
  style,
  ...props
}: {
  size: SupportedFontSize | ResponsiveValue<SupportedFontSize>,
  style?: Object,
}) {
  return <Text size={size} style={{ marginTop: MARGIN_TOP[size], ...style }} {...props} />;
}



// WEBPACK FOOTER //
// ./src/ui/components/core/BodyText.js